import { createFileRoute } from '@tanstack/react-router'

import { NnppComponentsPage } from '@/src/pages/nnpp/components/NnppComponentsPage'

export const Route = createFileRoute('/nnpp/components/')({
  component: NnppComponentsPage,
  staticData: { layout: { enableScrolling: true, showSearchBar: false } },
})
